import { Type } from "class-transformer";
import UserBusiness from "../UserBusiness/UserBusiness";

export default class UserBusinessOrder {
    public ID: string;
    @Type(() => UserBusiness)
    public userBusiness: UserBusiness;
}
